
<div class="flex-fill d-flex flex-column">
            <div class="column ms-2 me-2"><span class="color-legend channel-partner"></span> - Channel Partner</div>
    <div class="m-1 grid-fill" *ngIf="dealers && ready">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="dealers"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChangedShared($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="companyName" caption="Company" width="200" [sortIndex]="0" sortOrder="asc"></dxi-column>
            <dxi-column dataField="contactName" width="150"></dxi-column>
            <dxi-column dataField="billAddress1"></dxi-column>
            <dxi-column dataField="billAddress2"></dxi-column>
            <dxi-column dataField="billCity"></dxi-column>
            <dxi-column dataField="billState" width="80"></dxi-column>
            <dxi-column dataField="billZip" caption="Zip" width="80"></dxi-column>
            <dxi-column dataField="phone1"></dxi-column>
            <dxi-column dataField="phone2"></dxi-column>
            <dxi-column dataField="email" caption="Sales Email" width="200"></dxi-column>
            <dxi-column dataField="aPEmail" width="200"></dxi-column>
            <dxi-column dataField="salesRep.name" caption="SalesRep" width="70"></dxi-column>
            <dxi-column dataField="fax"></dxi-column>
            <dxi-column dataField="calculatedPricingTier" caption="Calculated Tier" width="100"></dxi-column>
            <dxi-column dataField="pricingTier.name" caption="Tier Override" width="100"></dxi-column>
            <dxi-column dataField="isValidated" caption="Validated" width="70"> </dxi-column>
            <dxi-column dataField="isReadyToExport" caption="Ready To Export" width="70"></dxi-column>
            <dxi-column *ngIf="canSeeAdmin" dataField="quickBooksId"></dxi-column>
            <dxi-column *ngIf="canSeeAdmin" dataField="quickBooksLastExport" caption="QB Export" width="100"></dxi-column>
            <dxi-column *ngIf="canSeeSales" dataField="sales" caption="YTD Sales" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
            <dxi-column *ngIf="canSeeSales" dataField="yearlySales" [caption]="salesCaption" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
            <dxi-column dataField="pastDue" caption="Past Due" width="70"> </dxi-column>
            <dxi-column dataField="inactive" caption="Inactive" width="70"> </dxi-column>
            <dxi-column dataField="loadedMilesHtml" caption="Loaded Miles" width="100" [encodeHtml]="false"> </dxi-column>

            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="dealer-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button [hidden]="false" (click)="open()" class="btn btn-secondary ms-2">New</button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="!canSeeAdmin"
                >
                    Delete
                </button>
                <button
                    class="btn btn-success ms-4"
                    (click)="emailDealers(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    [hidden]="!canSeeAdmin"
                >
                    Email Dealer List
                </button>
                <button
                    class="btn btn-success ms-4"
                    (click)="addDealerNote(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="!canSeeAdmin"
                >
                    Add Dealer Note
                </button>
                <button
                    class="btn btn-warning ms-4"
                    (click)="bulkEdit(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    [hidden]="readOnly"
                >
                    Bulk Edit
                </button>
                <button
                    class="btn btn-success btn-sm ms-4"
                    (click)="createCredit(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="!canSeeAdmin"
                >
                    Add Credit
                </button>
                <button class="btn btn-sm btn-warning ms-2" (click)="toggleShowAll()">{{ showAll ? 'Hide Inactive' : 'Show All' }}</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="dealers" class="me-3">
                    <span *ngIf="uniqueYears && canSeeSales">
                        <label class="me-2">Filter Sales by Year:</label>
                        <dx-select-box class="me-2" [(value)]="filterSalesYear" [width]="'100px'" [items]="uniqueYears" (onSelectionChanged)="salesYearChanged($event)">
                        </dx-select-box>
                    </span>
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
